import { SpiceLevel } from 'common/SpiceLevels';
import { isNil } from 'lodash';
import styled from 'styled-components';
import { Border, Colors, FontSize, FontWeight, Spacing } from 'web-common/src/shared/styles';
import { SpiceTag } from '../SpiceTagV2';

interface ICustomizationTagsProps {
  spiceLevel?: SpiceLevel;
  servingSize?: string;
}

const Tag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  color: ${Colors.GRAY_DARK_15};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.SEMI_BOLD};

  width: fit-content;
  background: ${Colors.GRAY_LITE_30};
  border-radius: ${Border.Radius.S};
  height: ${Spacing.SINGLE_HALF};
  padding-left: ${Spacing.HALF};
  padding-right: ${Spacing.HALF};
`;

export const CustomizationTags: React.FC<ICustomizationTagsProps> = ({ servingSize, spiceLevel }) => (
  <>
    {!isNil(servingSize) && <Tag>{servingSize}</Tag>}
    {!isNil(spiceLevel) && (
      <Tag>
        <SpiceTag spiceLevel={spiceLevel} size={16} />
      </Tag>
    )}
  </>
);
